import React from 'react';

import {Album, Song} from '../../../../../types';
import {ResourceDetails} from '../ResourceDetails';
import styles from './AlbumDetails.module.scss';

interface Props {
  id: Album['id'];
  name: string;
  artistName: string;
  artwork: string;
  tracks: Song[];
  trackCount: number;
  likes: number;
  catalog?: boolean;
  onPlay(): void;
}
export function AlbumDetails(props: Props) {
  return (
    <>
      <ResourceDetails
        ordered
        type="album"
        creatorName={props.artistName}
        {...props}
      />
      {!props.catalog && (
        <div className={styles.ShowComplete}>
          <a href="link to where album is">Show complete album</a>
        </div>
      )}
    </>
  );
}
